import { gql } from '@apollo/client';

export const UPDATE_WORKFLOW_STEP_IN_TRANSITION_MODE = gql`
    mutation UpdateWorkflowStep($currentWorkflowStepId: WorkflowStepInput!, $nextWorkflowStepId: WorkflowStepInput!) {
        updateCurrentStep: updateWorkflowStep(workflowStep: $currentWorkflowStepId) {
            success
            workflowStep {
                _id
                status
                responsible {
                    responsibleID
                }
                dueDate
            }
        }

        updateNextStep: updateWorkflowStep(workflowStep: $nextWorkflowStepId) {
            success
            workflowStep {
                _id
                status
            }
        }
    }
`;
